import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Helmet from 'react-helmet';
import { CircularProgress } from '@material-ui/core';

import DirectDonorsToDonationPage from 'retired/DirectDonorsToDonationPage';
import { selectOrganization, selectUser } from 'entities/user/selectors';

import { Privileges } from '../../utils/privileges';

import ConnectWithStripeBlock from './ConnectWithStripeBlock';

const OrganizationStripeIntroPage = () => {
  const organization = useSelector(selectOrganization);
  const user = useSelector(selectUser);

  const stripeId = organization?.stripe?.userId;

  const history = useHistory();

  if (!user) {
    return (
      <>
        <Helmet title="Connect with Stripe" />
        <h1>Connect with Stripe</h1>
        <CircularProgress />
      </>
    );
  }

  if (stripeId) {
    history.replace('/donations');
  }

  const setupAllowed = user.hasPrivilege(Privileges.DONATION_MANAGE_RULES);

  return (
    <>
      <Helmet title="Connect with Stripe" />
      <h1>Connect with Stripe</h1>
      <>
        {organization && (
          <>
            {setupAllowed ? (
              <ConnectWithStripeBlock>
                <p>
                  <em>
                    <DirectDonorsToDonationPage organization={organization} />
                  </em>
                </p>
              </ConnectWithStripeBlock>
            ) : (
              <div>Uh oh! Looks like you don&apos;t have permission to set up donations.</div>
            )}
          </>
        )}
      </>
    </>
  );
};

export default OrganizationStripeIntroPage;
